var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReplyAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9995 1.56026C16.9995 0.620262 18.1395 0.140262 18.8095 0.810262L23.2895 5.29026C23.6795 5.68026 23.6795 6.31026 23.2895 6.70026L18.8095 11.1803C18.1395 11.8603 16.9995 11.3803 16.9995 10.4403C16.9995 10.1603 17.1095 9.89026 17.3095 9.69026L20.9995 6.00026L17.3095 2.31026C17.1095 2.11026 16.9995 1.84026 16.9995 1.56026ZM10.9995 3.00026V1.41026C10.9995 0.520262 12.0795 0.0702616 12.7095 0.700262L17.2995 5.29026C17.6895 5.68026 17.6895 6.31026 17.2995 6.70026L12.7095 11.2903C12.0795 11.9203 10.9995 11.4703 10.9995 10.5803V8.90026C5.99953 8.90026 2.49953 10.5003 -0.000469208 14.0003C0.999531 9.00026 3.99953 4.00026 10.9995 3.00026Z",
    fill: "#282860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyAll);
export default __webpack_public_path__ + "static/media/replyAll.1801a5def4ad5852d79351c0742e25cd.svg";
export { ForwardRef as ReactComponent };